export const AMPLITUDE_IDENTIFY_URL =
  process.env.REACT_APP_AMPLITUDE_USER_IDENTIFY_URL || "";

export type RemoteConfig = {
  _source: string;
  _value: string;
};
export const AMPLITUDE_API_KEY = "amplitude_api_key";

export const USER_PROPERTIES = {
  TOTAL_NUMBER_OF_CONTRACT_CREATED: "totalNumberOfContractCreated",
  TOTAL_NUMBER_OF_CONTRACT_DELETED: "totalNumberOfContractDeleted",
  TOTAL_NUMBER_OF_DELIVERY_CONFIRMED: "totalNumberOfDeliveryConfirmation",
  TOTAL_NUMBER_OF_ESCALATION: "totalNumberOfEscalation",
  TOTAL_NUMBER_OF_INSPECTION_CONFIRMATION:
    "totalNumberOfInspectionConfirmation",
};
